import type { IDeparture } from '../../../../models/departure.model';
import { DepartureOrArrivalApiModelBase } from './departure-or-arrival-base.api-models';
import { ServiceJourneyApiModel } from './service-journey.api-model';

export class DepartureApiModel extends DepartureOrArrivalApiModelBase {
  public static mapToBusinessModel(apiModel: DepartureApiModel): IDeparture {
    return {
      isCancelled: apiModel.isCancelled,
      plannedTime: apiModel.plannedTime,
      stopPointGid: apiModel.stopPoint.gid,
      stopPointName: apiModel.stopPoint.name,
      platform: apiModel.stopPoint.platform,
      estimatedTime: apiModel.estimatedTime,
      serviceJourney: ServiceJourneyApiModel.mapToBusinessModel(apiModel.serviceJourney),
    };
  }
}
